module.exports = __webpack_public_path__ + "img/graph.3ce347d5.svg";